import { Property } from '@sales-app/api/GeoLocation/GeoLocation'
import { SearchMapActions, useSearchMapContext } from '@sales-app/context/searchMap'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { Fragment, memo, useEffect, useState } from 'react'

import { useMobile } from '@/hooks/useMobile'

import { PopupWrapper } from './MapPopup.styles'
import { PopupContent } from './PopupContent'

export const MapPopup = memo(function Popup({ bookablePerson }: { bookablePerson: WorkspaceTab }): JSX.Element {
  const [{ popup, size }, dispatch] = useSearchMapContext()
  const { isMobile } = useMobile()
  const [remValue, setRemValue] = useState(16)

  useEffect(() => {
    setRemValue(parseFloat(getComputedStyle(document.documentElement).fontSize))
  }, [])

  return (
    <Fragment>
      {popup && !isMobile ? (
        <PopupWrapper id="map-popup" key={popup.id} mapProperty={popup?.mapProperty} mapSize={size} remValue={remValue}>
          <div
            className="h-full"
            onMouseEnter={() => dispatch(SearchMapActions.setIsMouseOverPopup(true))}
            onMouseLeave={() => dispatch(SearchMapActions.setIsMouseOverPopup(false))}
            role="button"
            tabIndex={0}
          >
            <PopupContent bookablePerson={bookablePerson} property={popup as Property} />
          </div>
        </PopupWrapper>
      ) : null}
    </Fragment>
  )
})
